// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"1efd477d","127":"1e5e81aa","205":"f81a2f07","259":"44bd4691","368":"0c1f59bc","386":"1738d7f5","419":"d324f32d","518":"bc829cde","660":"506d0c69","661":"d442610a","768":"8f7bd85e","938":"2b9f83d0","969":"cb133de7"}[chunkId] + ".chunk.js";
};